import { render, staticRenderFns } from "./ecomHeader.vue?vue&type=template&id=06a915c7&scoped=true&"
import script from "./ecomHeader.vue?vue&type=script&lang=js&"
export * from "./ecomHeader.vue?vue&type=script&lang=js&"
import style0 from "./ecomHeader.vue?vue&type=style&index=0&id=06a915c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a915c7",
  null
  
)

export default component.exports